import { gql } from "@apollo/client";
import { Def_MutationResponse } from "../../UserCalls/GQLCalls/userCalls";

export const CLEAR_ALL_TABLES = gql`
mutation ClearAllTables($domain: String!, $lanControllerId: Int!) {
	controller {
		clearAllTables(domain: $domain, lanControllerId: $lanControllerId) {
			code
			success
			message
		}
	}
}
`

export interface ClearAllTablesResponse {
	controller: {
		clearAllTables: Def_MutationResponse | null
	}
}

export interface ClearAllTablesArgs {
	domain: string;
	lanControllerId: number;
}

